import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Header from "../Header";
import { Fragment } from "react";
import { getSupportPartners } from "../data/support";

const Container = styled.div`
  padding: 0 15px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;

const Description = styled.div`
  color: #69707f;

  font-size: 18px;
  margin: 20px 0px 40px 0px;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.07);
  padding: 15px 0px 0px 15px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;
const TopBlock = styled.div`
  display: flex;

  align-items: center;
`;

const Icon = styled.img<{ width: number; height: number }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin-right: 15px;
`;

const RightBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
`;

const CenterText = styled.div`
  color: #69707f;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
`;
const Text = styled.div`
  color: #69707f;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 400;
  white-space: break-spaces;
`;

const FeedBackText = styled.a`
  color: #0034a4;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 400;
  text-decoration-line: none;
  white-space: break-spaces;
`;

const MultipleFeedBackText = styled.div`
  color: #0034a4;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 400;
  white-space: break-spaces;
`;

const SeeMoreText = styled(FeedBackText)`
  font-size: 12px;

  align-self: flex-end;
  margin-right: 10px;
`;

const Support = () => {
  const { t, i18n } = useTranslation();
  const partners = getSupportPartners(
    i18n.resolvedLanguage ?? i18n.language,
  );

  return (
    <>
      <Header />
      <Container>
        <Description>{t("description")}</Description>
        {partners.map((partner) => {
          return (
            <Card key={partner.id}>
              <TopBlock>
                <Icon
                  width={partner.width}
                  height={partner.height}
                  src={`${process.env.PUBLIC_URL}/${partner.image}`}
                />
                <RightBlock>
                  <CenterText>{t("customer_center")}</CenterText>
                  {partner.link.map((link, index) => {
                    const isMultipleItemsLink = "items" in link;
                    if (isMultipleItemsLink) {
                      return (
                        <MultipleFeedBackText key={index}>
                          {t(link.info)}
                          {link.items.map((item, itemIndex) => (
                            <Fragment key={`${item.href}-${item.label}`}>
                              {itemIndex > 0 && ", "}
                              <FeedBackText
                                href={item.href || undefined}
                                target="_blank"
                              >
                                {t(item.label)}
                              </FeedBackText>
                            </Fragment>
                          ))}
                        </MultipleFeedBackText>
                      );
                    }

                    // singleItemLink
                    return (
                      <FeedBackText
                        key={index}
                        href={link.href || undefined}
                        target="_blank"
                      >
                        {link.info && t(link.info)}
                        {t(link.label)}
                      </FeedBackText>
                    );
                  })}
                  <Text>
                    {t("operation_time")}
                    <br />
                    {t(partner.opTime)}
                  </Text>
                </RightBlock>
              </TopBlock>
              {partner.seeMoreLink && (
                <SeeMoreText href={t(`${partner.seeMoreLink}`)} target="_blank">
                  {t("see_more")}
                </SeeMoreText>
              )}
            </Card>
          );
        })}
      </Container>
    </>
  );
};
export default Support;
